import React from 'react';
import { useSelector } from 'react-redux';
import { Field } from 'react-final-form';

import RenderDropdown from 'forms/RenderDropdown';
import { selectSprayMethodOptions } from './selectors';

interface Props {
    name: string;
    label?: string;
    validate?: any;
    nullOnUnmount?: boolean;
    placeholder?: string;
}

export default function SprayMethodDropdown(props: Props): React.ReactElement {
    const { name, label, validate, nullOnUnmount = false, placeholder } = props;

    const options = useSelector(selectSprayMethodOptions);

    return (
        <Field
            component={RenderDropdown as any}
            subscription={{
                value: true,
                touched: true,
                error: true
            }}
            name={name}
            label={label || 'Spray method'}
            fluid
            search
            selection
            clearable
            selectOnBlur={false}
            validate={validate}
            options={options}
            nullOnUnmount={nullOnUnmount}
            placeholder={placeholder}
        />
    );
}
